import { Component, OnInit, EventEmitter, ChangeDetectorRef, Input, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/core/services/login.service';
import { DirDetailsService } from 'src/app/modules/directory/services/dir-details.service';
import { FeedService } from '../../services/feed.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { FeedImageComponent } from '../feed-image/feed-image.component';
//import { FormGroup } from '@angular/forms';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { FollowingComponent } from '../following/following.component';
import { FollowersComponent } from '../followers/followers.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/core/toast.service';
import { CommonService } from '../../services/common.service';
import { BasicInfoTabService } from '../../../dashboard/modules/my-directory/services/basic-info-tab.service';
import { AddNewsfeedPopupComponent } from '../add-newsfeed-popup/add-newsfeed-popup.component';
import { SlsService } from 'src/app/core/services/sls.service';
import { v4 as uuidv4 } from 'uuid';
import { ClassGetter } from '@angular/compiler/src/output/output_ast';
import { response } from 'express';
import { BannersInfoTabService } from 'src/app/modules/dashboard/modules/banners/services/banners-info-tab-service';
import { SwiperComponent, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { PermissionDeniedModalComponent } from 'src/app/modules/home/components/permission-modal/permission-denied-modal.component';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { PostViewerComponent } from 'src/app/shared/modules/components/post-viewer/post-viewer.component';
import { IncomProfComponent } from 'src/app/modules/sign-up/components/incom-prof/incom-prof.component';
import { isObservable, Observable, Subject  } from 'rxjs';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { Tables } from '../../../../shared/enum/tables.enum';
import { Overlay } from '@angular/cdk/overlay';
import { CourseSectionService } from 'src/app/modules/profile/services/course-section.service';
import { CatalogueService } from 'src/app/modules/dashboard/modules/my-catalogues/services/catalogue.service';
import { DeletePopupComponent } from 'src/app/modules/dashboard/delete-popup/delete-popup.component';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
  selector: 'app-feed',
  templateUrl: './feed.component.html',
  styleUrls: ['./feed.component.scss'],
  animations: [
    trigger("openCloseStatus", [
      state('true', style({ height: '*', opacity: '1' })),
      state('false', style({ height: '90px', opacity: '1' })),
      transition("false <=> true", [animate(500)])
    ])
  ],
})
export class FeedComponent implements OnInit {
  newsfeedsUser: any[] = [];
receivedId: any;
  offset = 0;
  limit: number;
  loading = false;
  noMoreData = false;
  totalFeedsCount: number = 0;

  isLoading = false;
  subscriptionPermissions: any;
  categoriesFilter: any[] = [];
  userProfileData :any
  totalMembersCount: number = 0;
  communityName = '';
  searchSubject = new Subject<string>();


  @ViewChildren('rightNavSlide') RightNavBNSlideRefs!: QueryList<ElementRef>;
  rightNavBNObservers: IntersectionObserver[] = [];
  rightNavViewedBNIds: Set<number> = new Set();
  @ViewChild('businessViewport') businessViewport!: CdkVirtualScrollViewport;
  @ViewChild('practiceViewport') practiceViewport!: CdkVirtualScrollViewport;
  @ViewChild('professionalViewport') professionalViewport!: CdkVirtualScrollViewport;

  @ViewChildren('listViewSlide') listViewBNSlideRefs!: QueryList<ElementRef>;
  listViewBNObservers: IntersectionObserver[] = [];
  listviewedBNIds: Set<number>[] = [];

  mainMenu: boolean = true;
  @Input() selectedUsers: any[] = [];
  public onlineStatus = 'online';
  followingggIds: any[];


  followedUsers: { [key: string]: any } = {};
  loginData: any;
  notFollowedBusinesses: any[] = [];
  notFollowedDentalPractice: any[] = [];
  notFollowedDentalProfessionals: any[] = [];
  newsfeeds: any[] = [];
  followingggIdSet: any;
  markFollowedInSearchResults: any;
  followingLoaded: boolean;
  followingggPenIds: any[];
  followingggPenIdsSet: Set<any>;

  searchFilterValues: any
  catalogueFilter: boolean = false;
  isLoadingFeeds: boolean = false;


  followStatus: string = 'Follow'; //  Declare it here
  categories: any[] = [];
  selectedCategory: any = null;
  suggestedDentalPractice = [];
  suggestedDentalProfessional = [];
  suggestedDentalBusiness = [];
  filteredDentalPractice = [];
  filteredDentalProfessional = [];
  filteredDentalBusiness = [];
  searchQuery: string = '';
  displayQuery: string = '';
  selectedUser: any = null;
  selectedCompany: any = null;
  activeRoute: any;
  business: any;

  suggestedCompanyName: {
    company_name: any; id: any; name: any; email: any; phone: any; logo: any; type: any; followStatus?: string;
  }[];
  filteredCompanyNames: { id: any; name: any; email: any; phone: any; logo: any; type: any; followStatus?: string; }[];
  noResultsFound: boolean;
  activeStatus: string = 'PUBLISHED';
  newsfeedCount: any = 0;
  businessid: any;

  followercount: any;
  countOfFollowing: any;
  countOfFollowers: any;
  totalFollowing: any;

  followers: any;
  identifyName: string;
  followRequests: any[] = [];
  visibleAll: any[];
  showpending: boolean = false;
  followingUserStatus: any;
  storedFollowStatuses: { [userId: string]: string } = {};
  followStatusPractice: any[];
  directoryFollowers: any[] = [];
  practicefollowedIds: any;
  notFollowedCompanies: { company_name: any; id: any; name: any; email: any; phone: any; logo: any; type: any; followStatus?: string; }[];
  initialSearchFilterValues: any;
  showCreateButton: boolean;
  showMessage: string;
  newsFeedPermissionLimit: any;
  allCountsAreZero: any;

  selectEntity(entity: any, type: string) {
    if (type === 'user') {
      this.selectedUser = entity;
      this.selectedCompany = null;
      this.displayQuery = entity.name;
    } else if (type === 'company') {
      this.selectedCompany = entity;
      this.selectedUser = null;
      this.displayQuery = entity.company_name;
    }
    this.setActiveStatus("PUBLISHED");
    this.selectedCategory = null;
    this.searchQuery = this.displayQuery;
    setTimeout(() => {
      this.searchQuery = "";
    }, 100);
  }
  getInitials(name: string): string {
    if (!name) return '';
    const words = name.split(' ');
    let initials = words[0].charAt(0);
    if (words.length > 1) {
      initials += words[words.length - 1].charAt(0);
    }
    return initials.toUpperCase();
  }
  feedStatus = false;
  commentShow = false;
  categoriesLoaded = false;


  loginDetails: any;
  communityId: string | null = null;
  feedIndexUnlike: any;
  count: any;
  addLikes = {
    dental_practice_id: null,
    dental_professional_id: null,
    dental_supplier_id: null,
    news_feeds_id: null
  }
  addCommentsData = {
    dental_practice_id: null,
    dental_professional_id: null,
    dental_supplier_id: null,
    news_feeds_id: null,
    comments: null,
  }
  favoriteStatus = false;
  feedIndex: any;
  userData: any;
  userFollowing: any;
  followingIds = [];
  followersIds = [];
  userFollowers: any;
  subscription: any;
  user_id: any
  title: any;
  pendingCount: number = 0;
  publishedCount: number = 0;
  unpublishedCount: number = 0;

  followingStatus = false;
  visibleFollowRequests: any[] = [];
  showAll = false;
  directoryrespose: any;
  bannerImage: any;

  scrollingFinished = new EventEmitter<void>();
  constructor(private overlay:Overlay ,private Commonservice:CommonServicesForAllModules,private basicInfoTabService: BasicInfoTabService, private feedService: FeedService, private _fb: FormBuilder, private toast: ToastService, private _dialog: MatDialog, private loginService: LoginService, private router: Router, private dirService: DirDetailsService, private spinner: NgxSpinnerService, private commonService: CommonService, private dialog: MatDialog, private sls: SlsService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private bannersInfoTabService: BannersInfoTabService, private CourseSectionService: CourseSectionService,private catalogueService: CatalogueService) { }
  goToDetails(business: any) {
    
    this.router.navigate(['/directory/directory-details', business.id], { state: { business } });
  }

  // Banner Advertisement
  ngAfterViewInit() {
    this.rightNavBannerSlides();
    this.listViewBNSlides();
    this.RightNavBNSlideRefs.changes.subscribe(() => {
      this.rightNavBannerSlides();
    });
    this.listViewBNSlideRefs.changes.subscribe(() => {
      this.listViewBNSlides();
    });
  }


  ngOnInit(): void {



    this.loginDetails = this.loginService.getLoginData();
      this.route.queryParams.subscribe(params => {
    
     this.receivedId = params['id'];
     if (this.receivedId) {

      this.activeStatus = 'PENDING';
      this.getNewsFeed();

    }
 
      });

// search feed

this.searchSubject
    .pipe(
      debounceTime(500),         
      distinctUntilChanged()      
    )
    .subscribe((searchText) => {
      this.searchQuery = searchText;
      this.getNewsFeed();         
      this.fetchCountsBasedOnFilter();
    });


    this.route.paramMap.subscribe(params => {
      this.communityId = params.get('id');
      if (this.communityId) {
        this.Commonservice.GetByField(Tables.Directories , 'community_id',this.communityId ,['banner_image']).subscribe({
          next: (banner:any) => {
            this.bannerImage = banner?.banner_image || null;
            this.communityName = banner?.business_name
          },
          error: (err) => {
            console.error("Error fetching banner:", err);
            this.bannerImage = null;
          },
          complete: () => {
            console.log("Banner API call completed");
          }
        });
        this.categoriesLoaded = false;
        this.fetchCommunityMembersCount();
        this.fetchCountsBasedOnFilter();
        this.getNewsFeed();
        this.loadCategories();
      }
    });
    const id = this.route.snapshot.queryParamMap.get('id');
    const popup = this.route.snapshot.queryParamMap.get('popup') === 'true';

    if (popup && id) {
      const dialogRef = this._dialog.open(PostViewerComponent, {
        width: '50%',
        height: 'auto',
        maxHeight: '90vh',
        panelClass: 'custom-dialog',
        data: { id }
      });
      dialogRef.afterClosed().subscribe(() => {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { popup: null, id: null, type: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      });
    }
    this.loadUserNewsfeeds();
    this.checkCategoryPermissions();
    this.subscription = this.commonService.on('call-parent').subscribe(() => this.callAgain());
    this.loginDetails = this.sls.get('loginData');

    const newsFeedPermission = this.loginDetails?.subscription_permissions?.modules
      ?.find((mod: any) => mod.name === 'news_feed_modules_permission');

    this.showCreateButton = true;
    this.showMessage = "";
    if (newsFeedPermission?.permission) {
      this.newsFeedPermissionLimit = newsFeedPermission.count;
      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);
      const andList: any[] = [
        {
          status: { "_in": ["PUBLISHED", "PENDING"] }
        },
        {
          created_at: {
            _gte: startDate.toISOString(),
            _lt: endDate.toISOString()
          }
        }
      ];
      if (this.loginDetails.type == "SUPPLIER") {
        andList.push({
          dental_supplier_id: { _eq: this.loginDetails.id }
        });
      }
      if (this.loginDetails.type == "PRACTICE") {
        andList.push({
          dental_practice_id: { _eq: this.loginDetails.id }
        });
      }
      if (this.loginDetails.type == "PROFESSIONAL") {
        andList.push({
          dental_professional_id: { _eq: this.loginDetails.id }
        });
      }
      this.feedService.getMonthlyNewsCount(andList, this.newsFeedPermissionLimit).subscribe(data => {
        this.allCountsAreZero = data.every(item => item.count <= 0);
        if (this.allCountsAreZero) {
          this.showCreateButton = false;
          this.showMessage = "You have reached maximum limit but you can save them as draft for future. For mor details please contact the admin";
        }
      });

    }
    this.getUsers();
    this.getSuggestedUnfollowusers();
    this.SuggestedBusiness();
    this.fetchCountsBasedOnFilter();
    this.loadSuggestedDentalPractice();
    this.loadSuggestedCompanies();
    this.loadSuggestedDentalProfessionals();
    this.loadUserProfile();
    this.fetchUserCounts();
    this.getPendingUsers();
    this.loadUserFollowing();
    this.getFollowDirectoriesData();
    this.getBannersCategory();
    this.getFilteredBanners();
      this.loadCatalogueData();
    this.loadCourseData();

  }



fetchCommunityMembersCount() {
  if (!this.communityId) return;

  this.feedService.getCommunityMembersTotalCount(this.communityId).subscribe({
    next: (res) => {
      this.totalMembersCount = res.count;
    },
    error: (err) => console.error('Failed to fetch community count', err),
  });
}
  
  getUsers() {
    this.dirService.getUsersCount(this.loginDetails.id).subscribe((data: any) => {
      this.count = data
      this.countOfFollowing = data.to_whome_i_am_following.length
      this.countOfFollowers = data.who_is_following.length
      this.totalFollowing = data.to_whome_i_am_following
      this.getSuggestedUnfollowusers();
    });

    const followingList = this.sls.get('followingList');
    const followerList = this.sls.get('followerList');
    if (followingList || followerList) {

      this.mainMenu = false;
      this.identifyName = followingList ? 'Following' : '';
    }

  }

  getPendingUsers() {
    this.dirService.getUsersCountPending(this.loginDetails.id).subscribe((data: any) => {
      const pendingRequests = data.who_is_following.map((follower: any) => {

        let user = null;

        if (follower.dental_admin) {
          user = {
            id: follower.id,
            fid: follower.dental_admin.id,
            name: follower.dental_admin.name,
            profile_image: '../../../../../assets/images/logo.svg', // default admin image
            type: 'ADMIN'

          };
        } else if (follower.dental_professional) {
          user = {
            id: follower.id,
            fid: follower.dental_professional.id,
            name: follower.dental_professional.name,
            profile_image: follower.dental_professional.profile_image || 'assets/images/default-profile.png',
            type: 'PROFESSIONAL'
          };
        } else if (follower.dental_practice) {
          user = {
            id: follower.id,
            fid: follower.dental_practice.id,
            name: follower.dental_practice.name,
            profile_image: follower.dental_practice.logo || 'assets/images/default-profile.png',
            type: 'PRACTICE'
          };
        } else if (follower.dental_supplier) {
          user = {
            id: follower.id,
            fid: follower.dental_supplier.id,
            name: follower.dental_supplier.name,
            profile_image: follower.dental_supplier.logo || 'assets/images/default-profile.png',
            type: 'SUPPLIER'
          };
        }

        return {
          followId: follower.id,
          ...user
        };
      });

      this.followRequests = pendingRequests;
      this.visibleFollowRequests = this.followRequests.slice(0, 1);
    });
  }


  seeAll(): void {
    this.showAll = true;
    this.visibleAll = this.followRequests;
    this.showpending = true
    this.mainMenu = false

  }

  approve(user: any): void {
    this.dirService.updateFollowStatus(user.id, 'APPROVED').then((res: any) => {
      if (res) {
        if (res.data.update_directory_followers_by_pk.id) {
          this.feedService.updateApprovalStatus(true);
        }
        this.visibleAll = this.visibleAll.filter(u => u.id !== user.id);
        this.visibleFollowRequests = this.visibleFollowRequests.filter(u => u.id !== user.id);
        this.toast.openSnackBar('Request accepted successfully');
      }
    });
  }

  reject(user: any): void {
    this.dirService.updateFollowStatus(user.id, 'DECLINED').then((res: any) => {
      if (res) {
        this.visibleAll = this.visibleAll.filter(u => u.id !== user.id);
        this.visibleFollowRequests = this.visibleFollowRequests.filter(u => u.id !== user.id);
        this.toast.openSnackBar('Request declined successfully');
      }
    });
  }

  getUserImage(user: any): string {
    if (user.type === "ADMIN") {
      return '../../../../../assets/images/logo.svg';

    } else if (user.type === "PROFESSIONAL") {
      return user.profile_image.url;
    } else if (user.type === "PRACTICE") {
      return user.profile_image.url;
    } else if (user.type === "SUPPLIER") {
      return user.profile_image.url;
    }
    return 'assets/images/default-user.png';
  }

  // Load suggested business

  limitBus = 10;
  offsetBus = 0;
  loadingBus = false;
  endOfData = false;

  SuggestedBusiness() {


    // if (this.loadingBus) return;
     if (this.loadingBus || this.communityId) return;
    this.loadingBus = true;

    this.feedService.getAllUserProfileBusiness(this.limitBus, this.offsetBus, this.loginDetails.id,this.loginDetails.type).subscribe((data: any) => {
      
      this.cdr.detectChanges();

      if (Array.isArray(data) && data.length > 0) {
        const newItems = data.
        map((user: any) => ({
          id: user.id,
          name: user.name || 'Unknown',
          email: user.email || '',
          phone: user.phone || null,
          logo: user.logo || 'https://via.placeholder.com/150',
          type: user.type,
          followStatus: user.directoryFollowersByFollowerDentalSupplierId?.[0]?.following_status || null,
          directories: user.directories[0]
        }));

        this.notFollowedBusinesses.push(...newItems);
        this.offsetBus += this.limitBus;
      } else {
        console.log("No more data to load");
      }

      this.loadingBus = false;
    }, error => {
      this.loadingBus = false;
      console.error("Failed to load suggested businesses", error);
    });
  }

  clickMe() {
    this.mainMenu = true
    this.sls.remove('followingList')

  }

  loadCategories() {
    if (this.categoriesLoaded) return;

    // Determine which service call to use
    const categories$ = this.communityId
      ? this.feedService.getNewsFeedsCategoriesByCommunity(this.communityId)
      : this.feedService.getNewsFeedsCategories();

    categories$.subscribe(
      data => {
        if (Array.isArray(data)) {
          this.categories = [
            { category_name: 'Catalog', created_at: new Date(), updated_at: new Date() },
            { category_name: 'Jobs', created_at: new Date(), updated_at: new Date() },
            { category_name: 'Learning Hub', created_at: new Date(), updated_at: new Date() },
            ...data
          ];
          this.categoriesLoaded = true;
        } else {
          console.error("Expected an array but received:", data);
        }
      },
      error => {
        console.error("Error fetching categories:", error);
        this.categories = [
          { category_name: 'Catalog', created_at: new Date(), updated_at: new Date() },
          { category_name: 'Jobs', created_at: new Date(), updated_at: new Date() },
          { category_name: 'Learning Hub', created_at: new Date(), updated_at: new Date() },
        ];
        this.categoriesLoaded = true;
      }
    );
  }



  // Load suggested practice

  limitPractice = 10;
  offsetPractice = 0;
  loadingPractice = false;
  endOfDataPractice = false;


  loadSuggestedDentalPractice(): void {
    // if (this.loadingPractice) return;
      if (this.loadingPractice || this.communityId) return;
    this.loadingPractice = true;

    this.feedService.getAllUserProfilePracice(this.limitPractice, this.offsetPractice, this.loginDetails.id, this.loginDetails.type).subscribe((data: any) => {
      this.cdr.detectChanges();

      if (Array.isArray(data) && data.length > 0) {
        const newItems = data.map(user => ({
          id: user.id,
          name: user.name || 'Unknown',
          email: user.email || '',
          phone: user.phone || null,
          logo: user.logo || 'https://via.placeholder.com/150',
          type: user.type,
          followStatus: user.directoryFollowersByFollowerDentalPracticeId?.[0]?.following_status || null,
          directories: user.directories[0]
        }));

        this.notFollowedDentalPractice.push(...newItems);
        this.offsetPractice += this.limitPractice;
      } else {
        console.log("No more practices to load");
      }

      this.loadingPractice = false;
    }, error => {
      this.loadingPractice = false;
      console.error("Error loading practices", error);
    });
  }

  // Load suggested companies
  private loadSuggestedCompanies(): void {
    this.feedService.getAllComapnyName().subscribe((data: any) => {
      if (Array.isArray(data)) {


        this.suggestedCompanyName = data.map(user => {

          return {
            id: user.id,
            company_name: user.company_name || 'Unknown',
            name: user.name || 'Unknown',
            email: user.email || '',
            phone: user.phone || '',
            logo: user.logo || 'https://via.placeholder.com/150',
            type: user.type,
            followStatus: user.directoryFollowersByFollowerDentalCompanyId?.[0]?.following_status || null
          };
        });

        this.filteredCompanyNames = [...this.suggestedCompanyName];
      } else {
        this.suggestedCompanyName = [];
        this.filteredCompanyNames = [];
      }
    });
  }


  // Load suggested professional

  professionalLimit = 10;
  professionalOffset = 0;
  isFetchingProfessionals = false;
  hasMoreProfessionals = true;

  loadSuggestedDentalProfessionals(): void {
    // if (this.isFetchingProfessionals || !this.hasMoreProfessionals) return;
        if (this.isFetchingProfessionals || !this.hasMoreProfessionals || this.communityId) return;

    this.isFetchingProfessionals = true;

    this.feedService.getAllUserProfileProfessional(this.professionalLimit, this.professionalOffset, this.loginDetails.id, this.loginDetails.type)
      .subscribe((data: any[]) => {

        this.cdr.detectChanges();
        if (Array.isArray(data) && data.length) {
          const mappedData = data.map(user => ({
            id: user.id,
            name: user.name || 'Unknown',
            email: user.email || '',
            phone: user.phone || null,
            profile_image: user.profile_image || 'https://via.placeholder.com/150',
            type: user.type,
            followStatus: user.directoryFollowersByFollowerDentalProfessionalId?.[0]?.following_status || null,
            directories: user.directories[0]
          }));


          this.notFollowedDentalProfessionals.push(...mappedData);
          // this.filteredDentalProfessional = [...this.suggestedDentalProfessional];
          this.professionalOffset += this.professionalLimit;
        } else {
          this.hasMoreProfessionals = false;
        }

        this.isFetchingProfessionals = false;
      });
  }


  // Load user following list
  private loadUserFollowing(): void {
    this.dirService.getUsersDetailsFollowing(this.loginDetails.id).subscribe((data) => {

      this.userFollowing = data;
      this.followingggIds = [];
      this.followingggPenIds = [];

      this.userFollowing.forEach(follo => {
        if (follo.follower_dental_practice_id && follo.following_status === "APPROVED") this.followingggIds.push(follo.follower_dental_practice_id);
        if (follo.follower_dental_professional_id && follo.following_status === "APPROVED") this.followingggIds.push(follo.follower_dental_professional_id);
        if (follo.follower_dental_supplier_id && follo.following_status === "APPROVED") this.followingggIds.push(follo.follower_dental_supplier_id);
      });

      this.userFollowing.forEach(follo => {
        if (follo.follower_dental_practice_id && follo.following_status === "PENDING") this.followingggPenIds.push(follo.follower_dental_practice_id);
        if (follo.follower_dental_professional_id && follo.following_status === "PENDING") this.followingggPenIds.push(follo.follower_dental_professional_id);
        if (follo.follower_dental_supplier_id && follo.following_status === "PENDING") this.followingggPenIds.push(follo.follower_dental_supplier_id);
      });

      this.followingggIdSet = new Set(this.followingggIds);
      this.followingggPenIdsSet = new Set(this.followingggPenIds);
      // this.followingLoaded = true;
      // this.markFollowedInSearchResults();
    });
  }

  // // Load user followers list
  // private loadUserFollowers(): void {
  //   this.dirService.getUsersDetailsFollowers(this.loginDetails.id).subscribe((data) => {
  //     this.userFollowers = data;
  //     this.followersIds = [];

  //     this.userFollowers.forEach(follo => {
  //       if (follo.dental_practice) this.followersIds.push(follo.dental_practice);
  //       if (follo.dental_professional) this.followersIds.push(follo.dental_professional);
  //       if (follo.dental_supplier) this.followersIds.push(follo.dental_supplier);
  //     });
  //   });
  // }


  fetchUserCounts(): void {
    const response = this.dirService.getUsersCount(this.loginDetails.id).subscribe((data: any) => {
      this.countOfFollowing = data.to_whome_i_am_following.length
      this.countOfFollowers = data.who_is_following.length
      this.followingIds = [
        ...(data.to_whome_i_am_following
          .filter((item: any) => item.follower_dental_professional_id && item.following_status === "APPROVED")
          .map((item: any) => {
            return {
              id: item.id,
              followingid: item.follower_dental_professional_id,
              name: item.follower_dental_professional?.name || "Unknown Professional",
              profile_image: item.follower_dental_professional.profile_image,
              type: 'PROFESSIONAL'
            };
          })),
        ...(data.to_whome_i_am_following
          .filter((item: any) => item.follower_dental_supplier_id && item.following_status === "APPROVED")
          .map((item: any) => {
            return {
              id: item.id,
              followingid: item.follower_dental_supplier_id,
              name: item.follower_dental_supplier?.name || "Unknown Supplier",
              profile_image: item.follower_dental_supplier.logo,
              type: 'SUPPLIER'
            };
          })),
        ...(data.to_whome_i_am_following
          .filter((item: any) => item.follower_dental_practice_id && item.following_status === "APPROVED")
          .map((item: any) => {

            return {
              id: item.id,
              followingid: item.follower_dental_practice_id,
              name: item.follower_dental_practice?.name || "Unknown Practice",
              profile_image: item.follower_dental_practice.logo,
              type: 'PRACTICE'
            };
          })),
        ...(data.to_whome_i_am_following
          .filter((item: any) => item.follower_company_id && item.following_status === "APPROVED")
          .map((item: any) => {

            return {
              id: item.id,
              followingid: item.follower_company_id,
              name: item.follower_company?.name || "Unknown Name",
              company_name: item.follower_company?.company_name || "Unknown Company",
              profile_image: item.follower_company?.logo,
              type: item.follower_company?.type
            };

          }))
      ];
      this.followersIds = [
        ...(data.who_is_following
          .filter((item: any) => item.dental_professional_id && item.following_status === "APPROVED")
          .map((item: any) => ({
            id: item.dental_professional_id,
            name: item.dental_professional?.name || "Unknown Professional",
            type: 'PROFESSIONAL'
          }))),
        ...(data.who_is_following
          .filter((item: any) => item.dental_supplier_id && item.following_status === "APPROVED")
          .map((item: any) => ({
            id: item.dental_supplier_id,
            name: item.dental_supplier?.name || "Unknown Supplier",
            type: 'SUPPLIER'
          }))),
        ...(data.who_is_following
          .filter((item: any) => item.dental_practice_id && item.following_status === "APPROVED")
          .map((item: any) => ({
            id: item.dental_practice_id,
            name: item.dental_practice?.name || "Unknown Practice",
            type: 'PRACTICE'
          }))),
        ...(data.who_is_following
          .filter((item: any) => item.follower_company_id && item.following_status === "APPROVED")
          .map((item: any) => ({
            id: item.follower_company_id,
            name: item.follower_company_id?.name || "Unknown Practice",
            type: 'PRACTICE'
          }))),
        ...(data.who_is_following
          .filter((item: any) => item.dental_admin_id && item.following_status === "APPROVED")
          .map((item: any) => ({
            id: item.dental_admin_id,
            name: item.dental_admin?.name || "Unknown Admin",
            type: 'ADMIN'
          })))
      ];
    });
  }


private loadUserProfile(): void {
  const userId = this.loginDetails.id;
  const userType = this.loginDetails.type;

  switch (userType) {
    case 'PROFESSIONAL':
      this.feedService.getUserProfileProfessional(userId).subscribe(data => {
        this.userProfileData = data;
      });
      break;

    case 'PRACTICE':
      this.feedService.getUserProfilePracice(userId).subscribe(data => {
        this.userProfileData = data;
      });
      break;

    case 'SUPPLIER':
      this.feedService.getUserProfileSuplier(userId).subscribe(data => {
        this.userProfileData = data;
      });
      break;

    default:
      console.warn('Unknown user type:', userType);
      break;
  }
}


  // Load user profile based on type
  // private loadUserProfile(): void {
  //   switch (this.loginDetails.type) {
  //     case "PROFESSIONAL":
  //       this.feedService.getUserProfileProfessional(this.loginDetails.id).subscribe(data => this.userData = data);
  //       this.basicInfoTabService.userProfDirectory(this.loginDetails.id).subscribe((data: any) => {
  //         if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === false) {
  //           console.log('22222222222')
  //           this._dialog.open(IncomProfComponent, {
  //             width: '30%',
  //             panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
  //             disableClose: true,
  //             data: this.loginDetails,
  //           });
  //           // this.router.navigate(['/profile/detail']);
  //         }

  //         // Case 2: Profile completed but no directory found
  //         else if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === true) {
  //           this._dialog.open(IncomProfComponent, {
  //             width: '30%',
  //             panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
  //             disableClose: true,
  //             data: this.loginDetails,
  //           });

  //           this.router.navigate(['/profile/directory/add']);
  //         }
  //       });

  //       break;

  //     case "SUPPLIER":
  //       this.feedService.getUserProfileSuplier(this.loginDetails.id).subscribe(data => this.userData = data);
  //               this.basicInfoTabService.userSupDirectory(this.loginDetails.id).subscribe((data: any) => {
  //         // Case 1: Profile not completed (check this first)
  //         if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === false) {
  //           this._dialog.open(IncomProfComponent, {
  //             width: '30%',
  //             panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
  //             disableClose: true,
  //             data: this.loginDetails,
  //           });

  //           // this.router.navigate(['/profile/detail']);
  //         }

  //         // Case 2: Profile completed but no directory found
  //         else if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === true) {
  //           this._dialog.open(IncomProfComponent, {
  //             width: '30%',
  //             panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
  //             disableClose: true,
  //             data: this.loginDetails,
  //           });

  //           this.router.navigate(['/profile/directory/add']);
  //         }
  //       });
        

  //       break;

  //     case "PRACTICE":
  //       this.feedService.getUserProfilePracice(this.loginDetails.id).subscribe(data => this.userData = data);
  //                   this.basicInfoTabService.userPracDirectory(this.loginDetails.id).subscribe((data: any) => {
  //         // Case 1: Profile not completed (check this first)
  //         if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === false) {
  //           this._dialog.open(IncomProfComponent, {
  //             width: '30%',
  //             panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
  //             disableClose: true,
  //             data: this.loginDetails,
  //           });

  //           // this.router.navigate(['/profile/detail']);
  //         }

  //         // Case 2: Profile completed but no directory found
  //         else if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === true) {
  //           this._dialog.open(IncomProfComponent, {
  //             width: '30%',
  //             panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
  //             disableClose: true,
  //             data: this.loginDetails,
  //           });

  //           this.router.navigate(['/profile/directory/add']);
  //         }
  //       });
  //       break;
  //   }
  // }


  removefilter() {
    this.selectedCategory = null;
    this.catalogueFilter = false;
    this.fetchCountsBasedOnFilter();
    this.getNewsFeed();
  }


  removesearch() {
    this.selectedUser = null;
    this.selectedCompany = null;
    this.displayQuery = "";
  }



  async onScroll(): Promise<void> {
    if (this.loading || this.noMoreData) return;

    this.loading = true;
    const offset = this.newsfeeds.length;
    const limit = this.selectedCategory?.category_name === 'Catalog' ? 6 : 3;
    const SearchData = this.searchQuery.toLowerCase();
    
     const { id: userId, type: roleType } = this.loginDetails;
     

    const fetchFeeds = () => {
      switch (this.selectedCategory?.category_name) {
        case undefined:
          return this.feedService.getNewsFeedsAllData(this.activeStatus, limit, offset, this.communityId,'', SearchData , userId, roleType);
        case 'Catalog':
          return this.feedService.getNewsFeedsAllData(this.activeStatus, limit, offset, this.communityId, 'CATALOGUE', SearchData , userId, roleType) ;
        case 'Jobs':
          return this.feedService.getNewsFeedsAllData(this.activeStatus, limit, offset, this.communityId,'JOBS', SearchData , userId, roleType);
        case 'Learning Hub':
          return this.feedService.getNewsFeedsAllData(this.activeStatus, limit, offset, this.communityId, 'LEARNHUB', SearchData , userId, roleType);
        default:
          return this.feedService.getFilteredNewsFeeds(
            this.activeStatus,
            limit,
            offset,
            [this.selectedCategory.id],
            this.communityId,
            SearchData,
            userId,
            roleType,
          );
      }
    };

    try {
      const result = fetchFeeds();

      if (isObservable(result)) {
        result.subscribe(
          (data: any[]) => {
             console.log('data-----------------',data)
            if (!data || data.length === 0) {
              this.noMoreData = true;
            } else {
              const mapped = data.map(feed => ({
                ...feed,
                __type: this.selectedCategory?.category_name?.toLowerCase() || 'newsfeed',
                created_at: new Date(feed.created_at)
              }));
              this.newsfeeds = [...this.newsfeeds, ...mapped];
              
              console.log('newsfeeds',this.newsfeeds)
            }
            this.loading = false;
          },
          error => {
            console.error('Feed Scroll Error:', error);
            this.loading = false;
          }
        );
      } else if (result && typeof (result as any).then === 'function') {
        const data: any[] = await (result as Promise<any[]>);
        if (!data || data.length === 0) {
          this.noMoreData = true;
        } else {
          const mapped = data.map(feed => ({
            ...feed,
            __type: this.selectedCategory?.category_name?.toLowerCase() || 'newsfeed',
            created_at: new Date(feed.created_at)
          }));
          this.newsfeeds = [...this.newsfeeds, ...mapped];
        }
        this.loading = false;
      }
    } catch (err) {
      console.error('Feed Scroll Error:', err);
      this.loading = false;
    }
  }

  
  getNewsFeed(): void {
    this.isLoadingFeeds = true;
    this.offset = 0;
    this.noMoreData = false;
    this.newsfeeds = [];

    const limit = this.selectedCategory?.category_name === 'Catalog' ? 6 : 3;
    
    const SearchData = this.searchQuery.toLowerCase();

    const { id: userId, type: roleType } = this.loginDetails;



    const fetchFeeds = () => {
      switch (this.selectedCategory?.category_name) {
        case undefined:
          return this.feedService.getNewsFeedsAllData(this.activeStatus, limit, this.offset, this.communityId, '', SearchData, userId, roleType );
        case 'Catalog':
          return this.feedService.getNewsFeedsAllData(this.activeStatus, limit, this.offset, this.communityId,'CATALOGUE', SearchData,userId, roleType);
        case 'Jobs':
          return this.feedService.getNewsFeedsAllData(this.activeStatus, limit, this.offset, this.communityId, 'JOBS', SearchData, userId, roleType);
        case 'Learning Hub':
          return this.feedService.getNewsFeedsAllData(this.activeStatus, limit, this.offset, this.communityId, 'LEARNHUB', SearchData, userId, roleType);
        default:
          return this.feedService.getFilteredNewsFeeds(
            this.activeStatus,
            limit,
            this.offset,
            [this.selectedCategory.id],
            this.communityId,
             SearchData,
            userId,
            roleType,

          );
      }
    };

    const handleResult = (data: any[]) => {
      if (!data || data.length === 0) {
        this.noMoreData = true;
        // this.newsfeeds = [];
      } else {
        this.newsfeeds = data.map(feed => ({
          ...feed,
          likesCount: feed.newsfeeds_likes_aggregate.aggregate.count,
            isLiked: feed.my_like?.length > 0,
            myLikeId: feed.my_like?.[0]?.id ?? null,
          __type: this.selectedCategory?.category_name?.toLowerCase() || 'newsfeed',
          created_at: new Date(feed.created_at)
        }));
        
      }
      this.isLoadingFeeds = false;
    };



    const handleError = (err: any) => {
      console.error('Feed Load Error:', err);
      // this.newsfeeds = []; //  Clear on error as well
      this.isLoadingFeeds = false;
    };

    const result = fetchFeeds();

    if (isObservable(result)) {
      result.subscribe(handleResult, handleError);
    } else if (result && typeof (result as any).then === 'function') {
      (result as Promise<any[]>).then(handleResult).catch(handleError);
    }
        
  }

  // filter news feed :
   filterNewsfeed(event: any) {
       const query = event.target.value;
  this.searchSubject.next(query);
   }


  // --------------------
  

  setActiveStatus(status: string): void {
    this.activeStatus = status;
    this.getNewsFeed();
  }

  // selectCategory
  selectCategory(category: any) {
    this.selectedCategory = category;
    this.catalogueFilter = category?.category_name === 'Catalog';
    this.getNewsFeed();
    this.fetchCountsBasedOnFilter();
  }

  totalCount:any;

  fetchCountsBasedOnFilter() {
  
    // if(this.loginDetails?.type !== 'ADMIN'){
    //  return;
    // }
      
    const categoryId = this.selectedCategory?.id;
    const categoryName = this.selectedCategory?.category_name;
    const isCatalogue = categoryName === 'Catalog';
    const isJobs = categoryName === 'Jobs';
    const isLearningHub = categoryName === 'Learning Hub';
    const SearchData = this.searchQuery.toLowerCase();
    switch (true) {

      //  CASE 1: Catalog
      case isCatalogue:
        this.fetchCountsForStatuses(status =>
          this.feedService.getCatalogueFeedsCount(status, this.communityId, SearchData)
        );
        break;
      //  CASE 2: Jobs
      case isJobs:
        this.fetchCountsForStatuses(status =>
          this.feedService.getJobsFeedsCount(status, this.communityId, SearchData)
        );
        break;

      //  CASE 3: Filtered Category
      case !!categoryId:
        this.fetchCountsForStatuses(status =>
          this.feedService.getFilteredNewsFeedsCount(status, [categoryId], this.communityId, SearchData)
        );
        break;

      //  CASE 4: Learning Hub
      case isLearningHub:
        this.fetchCountsForStatuses(status =>
          this.feedService.getLearningHubCount(status, this.communityId, SearchData)
        );
        break;

      //  CASE 5: Admin
      case this.loginDetails?.type === 'ADMIN':
        this.feedService.getAllNewsfeedAndJobsCounts(this.communityId, SearchData).subscribe({
          next: data => {
            const pending = data.pendingNews.aggregate.count ;
            const published = data.publishedNews.aggregate.count ;
            const unpublished = data.unpublishedNews.aggregate.count;
            
            this.pendingCount = pending;
            this.publishedCount = published;
            this.unpublishedCount = unpublished;
            this.setTotalBasedOnStatus();
          },
          error: err => console.error('Error fetching combined counts:', err)
        });
        break;

      //  CASE 6: Community Supplier
      case this.loginDetails?.type === 'SUPPLIER' && this.communityId !== null:
        const communityId = this.communityId;
        this.fetchCountsForStatuses(status =>
          this.feedService.getSupplierCommunityFeedsCountByCommunity(communityId, status, SearchData)
        );
        break;

      //  DEFAULT CASE (No match)
      default:
        break;
    }
  }
  private fetchCountsForStatuses(fetchFn: (status: string) => Observable<number>) {
    ['PENDING', 'PUBLISHED', 'UNPUBLISHED'].forEach(status => {
      fetchFn(status).subscribe({
        next: count => {
          if (status === 'PENDING') this.pendingCount = count;
          if (status === 'PUBLISHED') this.publishedCount = count;
          if (status === 'UNPUBLISHED') this.unpublishedCount = count;
          if (this.activeStatus === status) this.totalFeedsCount = count;
        },
        error: err => console.error(`Error fetching count for ${status}:`, err)
      });
    });
  }

  private setTotalBasedOnStatus() {
    if (this.activeStatus === 'PENDING') this.totalFeedsCount = this.pendingCount;
    if (this.activeStatus === 'PUBLISHED') this.totalFeedsCount = this.publishedCount;
    if (this.activeStatus === 'UNPUBLISHED') this.totalFeedsCount = this.unpublishedCount;
  }


  handleFeedStatusChange(feedData: Boolean) {
    if (feedData) {
      this.getNewsFeed();
      this.fetchCountsBasedOnFilter();
      this.commentShow = true;
    }
  }
  filterUsers(event: any) {

    const input = event.target.value?.toLowerCase() || '';

    if (input) {
      this.searchFilterValues = this.initialSearchFilterValues.filter(item =>
        item.name?.toLowerCase().includes(input)
      );
    } else {
      this.searchFilterValues = [...this.initialSearchFilterValues];
    }
    const query = this.searchQuery.toLowerCase();
    this.filteredDentalPractice = this.suggestedDentalPractice.filter(item =>
      item.name.toLowerCase().includes(query)
    );
    this.filteredDentalProfessional = this.suggestedDentalProfessional.filter(item =>
      item.name.toLowerCase().includes(query)
    );
    this.filteredDentalBusiness = this.suggestedDentalBusiness.filter(item =>
      item.name.toLowerCase().includes(query)
    );
    this.filteredCompanyNames = this.suggestedCompanyName?.filter(item =>
      item.company_name.toLowerCase().includes(query)
    );
    this.noResultsFound = !(this.filteredDentalPractice.length || this.filteredDentalProfessional.length || this.filteredDentalBusiness.length || this.filteredCompanyNames.length);
  }
  getAllFilteredResults() {
    return [
      ...this.filteredDentalBusiness,
      ...this.filteredDentalPractice,
      ...this.filteredDentalProfessional,
    ];
  }
  getAllFilteredCompanies() {
    return this.filteredCompanyNames;
  }


  onScrollingFinish() {
    //this.dataService.loadMore();
  }


  onScrollingFinished() {
    this.scrollingFinished.emit();
  }
  openDialog() {
    const dialog = this.dialog.open(AddNewsfeedPopupComponent, {
      width: '40%',
      panelClass: ['custom-modal'],
      data: { communityId: this.communityId },
      scrollStrategy: this.overlay.scrollStrategies.noop(),
    });
    dialog.afterClosed().subscribe(async (response) => {
      this.getNewsFeed();
      this.fetchCountsBasedOnFilter();
    })
  }
  followIngPopup() {
    if (this.followersIds.length) {
      const dialog = this._dialog.open(FollowingComponent, {
        width: '40%',
        panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
        disableClose: true,
        data: this.followersIds,
      });
    }
  }

  followersPopup() {
    if (this.followingIds.length) {
      this._dialog.open(FollowersComponent, {
        width: '40%',
        panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
        disableClose: true,
        data: this.followingIds,
      });
    }
  }

  callAgain() {

  }
  getSuggestedUnfollowusers() {
    const loginData = this.sls.get('loginData');
    if (!this.loginDetails || !this.loginDetails.id) {
      console.error("User not logged in");
      return;
    }


    // this.SuggestedBusiness();
    // this.loadSuggestedDentalPractice();
    // this.loadSuggestedDentalProfessionals();
    if (!this.suggestedDentalBusiness || this.suggestedDentalBusiness.length === 0) {
      console.error("Suggested businesses not available");
      return;
    }

    const followedIds = this.totalFollowing.map(f => f.follower_dental_supplier_id);
    const practicefollowedIds = this.totalFollowing.map(f => f.follower_dental_practice_id);
    const professionalfollowedIds = this.totalFollowing.map(f => f.follower_dental_professional_id);
    const companyFollowedIds = this.totalFollowing.map(f => f.follower_company_id);

    this.notFollowedCompanies = this.suggestedCompanyName?.filter(
      company => !companyFollowedIds?.includes(company.id)
    );

    this.notFollowedBusinesses = this.suggestedDentalBusiness.filter(
      business => !followedIds?.includes(business.id)
    );

    this.notFollowedDentalPractice = this.suggestedDentalPractice.filter(
      practice => !practicefollowedIds?.includes(practice.id)
    );


    this.notFollowedDentalProfessionals = this.suggestedDentalProfessional.filter(
      professional => !professionalfollowedIds?.includes(professional.id)
    );
    this.initialSearchFilterValues = [
      ...this.filteredDentalBusiness,
      ...this.notFollowedDentalPractice,
      ...this.notFollowedDentalProfessionals,
    ];

    this.searchFilterValues = [...this.initialSearchFilterValues];

    // -------- Company Match --------
    this.notFollowedCompanies?.forEach(company => {
      const match = this.directoryrespose?.find(item => {
        if (this.loginDetails.type === 'PRACTICE') {
          return item.dental_practice_id === this.loginDetails.id && item.follower_company_id === company.id;
        } else if (this.loginDetails.type === 'PROFESSIONAL') {
          return item.dental_professional_id === this.loginDetails.id && item.follower_company_id === company.id;
        } else if (this.loginDetails.type === 'SUPPLIER') {
          return item.dental_supplier_id === this.loginDetails.id && item.follower_company_id === company.id;
        }
        return false;
      });

      company.followStatus = match ? match.following_status : 'Follow';
    });

    // -------- Practice Match --------
    this.notFollowedDentalPractice?.forEach(practice => {
      const match = this.directoryrespose?.find(item => {
        if (this.loginDetails.type === 'PRACTICE') {
          return item.dental_practice_id === this.loginDetails.id && item.follower_dental_practice_id === practice.id;
        } else if (this.loginDetails.type === 'PROFESSIONAL') {
          return item.dental_professional_id === this.loginDetails.id && item.follower_dental_practice_id === practice.id;
        } else if (this.loginDetails.type === 'SUPPLIER') {
          return item.dental_supplier_id === this.loginDetails.id && item.follower_dental_practice_id === practice.id;
        }
        return false;
      });

      practice.followStatus = match ? match.following_status : 'Follow';
    });

    // -------- Professional Match --------
    this.notFollowedDentalProfessionals?.forEach(professional => {
      const match = this.directoryrespose?.find(item => {
        if (this.loginDetails.type === 'PRACTICE') {
          return item.dental_practice_id === this.loginDetails.id && item.follower_dental_professional_id === professional.id;
        } else if (this.loginDetails.type === 'PROFESSIONAL') {
          return item.dental_professional_id === this.loginDetails.id && item.follower_dental_professional_id === professional.id;
        } else if (this.loginDetails.type === 'SUPPLIER') {
          return item.dental_supplier_id === this.loginDetails.id && item.follower_dental_professional_id === professional.id;
        }
        return false;
      });

      professional.followStatus = match ? match.following_status : 'Follow';
    });

    // -------- Supplier Match --------
    this.notFollowedBusinesses?.forEach(business => {
      const match = this.directoryrespose?.find(item => {
        if (this.loginDetails.type === 'PRACTICE') {
          return item.dental_practice_id === this.loginDetails.id && item.follower_dental_supplier_id === business.id;
        } else if (this.loginDetails.type === 'PROFESSIONAL') {
          return item.dental_professional_id === this.loginDetails.id && item.follower_dental_supplier_id === business.id;
        } else if (this.loginDetails.type === 'SUPPLIER') {
          return item.dental_supplier_id === this.loginDetails.id && item.follower_dental_supplier_id === business.id;
        }
        return false;
      });

      business.followStatus = match ? match.following_status : 'Follow';
    });


    this.filteredDentalPractice?.forEach(practice => {
      const match = this.directoryrespose?.find(item => {
        if (this.loginDetails.type === 'PRACTICE') {
          return item.dental_practice_id === this.loginDetails.id && item.follower_dental_practice_id === practice.id;
        } else if (this.loginDetails.type === 'PROFESSIONAL') {
          return item.dental_professional_id === this.loginDetails.id && item.follower_dental_practice_id === practice.id;
        } else if (this.loginDetails.type === 'SUPPLIER') {
          return item.dental_supplier_id === this.loginDetails.id && item.follower_dental_practice_id === practice.id;
        }
        return false;
      });

      practice.followStatus = match ? match.following_status : 'Follow';
    });

    this.filteredDentalProfessional?.forEach(prof => {
      const match = this.directoryrespose?.find(item => {
        if (this.loginDetails.type === 'PRACTICE') {
          return item.dental_practice_id === this.loginDetails.id && item.follower_dental_professional_id === prof.id;
        } else if (this.loginDetails.type === 'PROFESSIONAL') {
          return item.dental_professional_id === this.loginDetails.id && item.follower_dental_professional_id === prof.id;
        } else if (this.loginDetails.type === 'SUPPLIER') {
          return item.dental_supplier_id === this.loginDetails.id && item.follower_dental_professional_id === prof.id;
        }
        return false;
      });

      prof.followStatus = match ? match.following_status : 'Follow';
    });

    this.filteredDentalBusiness?.forEach(business => {
      const match = this.directoryrespose?.find(item => {
        if (this.loginDetails.type === 'PRACTICE') {
          return item.dental_practice_id === this.loginDetails.id && item.follower_dental_supplier_id === business.id;
        } else if (this.loginDetails.type === 'PROFESSIONAL') {
          return item.dental_professional_id === this.loginDetails.id && item.follower_dental_supplier_id === business.id;
        } else if (this.loginDetails.type === 'SUPPLIER') {
          return item.dental_supplier_id === this.loginDetails.id && item.follower_dental_supplier_id === business.id;
        }
        return false;
      });

      business.followStatus = match ? match.following_status : 'Follow';
    });
  }


  followUser(business: any, event: Event, fromName: string): void {

    event.stopPropagation();

    const loginData = this.sls.get('loginData');
    if (!loginData?.id) return;

    const targetUserType = business.type?.toUpperCase();


    // Follow status is APPROVED for SUPPLIER and COMPANY, otherwise PENDING
    const followStatus = ['SUPPLIER', 'COMPANY'].includes(targetUserType) ? 'APPROVED' : 'PENDING';

    this.storedFollowStatuses[business.id] = followStatus;

    const formData = {
      id: uuidv4(),
      ...(loginData.type === 'SUPPLIER' ? { dental_supplier_id: loginData.id } : {}),
      ...(loginData.type === 'PROFESSIONAL' ? { dental_professional_id: loginData.id } : {}),
      ...(loginData.type === 'PRACTICE' ? { dental_practice_id: loginData.id } : {}),
      ...(loginData.type === 'ADMIN' ? { dental_admin_id: loginData.id } : {}),

      // Who is being followed
      ...(targetUserType === 'SUPPLIER' && fromName !== "company" ? { follower_dental_supplier_id: business.id } : {}),
      ...(targetUserType === 'PROFESSIONAL' && fromName !== "company" ? { follower_dental_professional_id: business.id } : {}),
      ...(targetUserType === 'PRACTICE' && fromName !== "company" ? { follower_dental_practice_id: business.id } : {}),
      ...(targetUserType === 'COMPANY' && fromName !== "company" ? { follower_company_id: business.id } : {}),
      ...(targetUserType === targetUserType && fromName === "company" ? { follower_company_id: business.id } : {}),
      following_status: followStatus
    };

    business.followStatus = followStatus;

    this.dirService.addFollowerData(formData).then(response => {

      this.notFollowedBusinesses = this.notFollowedBusinesses.filter(b => b.id !== business.id);

      this.feedService.updateApprovalStatus(true); // Update approval status
      this.fetchUserCounts();                      // Recalculate counts
      this.getFullUserDetails(business.id, business.type); // Log follow target info

      // Show confirmation based on the user type

      if (['SUPPLIER', 'COMPANY'].includes(targetUserType)) {
        this.toast.openSnackBar('You followed successfully');
      } else {
        this.toast.openSnackBar('You sent request successfully');
      }
    }).catch(error => {
      console.error('Error while adding follow:', error); // Log full error details for debugging
      this.toast.openSnackBar('Something went wrong. Please try again.');
    });
  }
  getStoredFollowStatus(user: any): string | null {
    return this.storedFollowStatuses?.[user.id] ?? user.followStatus ?? null;
  }


  getFollowDirectoriesData() {
    const loginData = this.sls.get('loginData');
    if (!loginData?.id) return;

    const loggedInId = loginData.id;

    this.dirService.getDirectoryFollowers().subscribe((response: any[]) => {
      if (!response || !Array.isArray(response)) {
        return;
      }
      this.directoryrespose = response;

    });
  }


  getFullUserDetails(userId: string, userType: string): void {
    switch (userType?.toUpperCase()) {
      case 'SUPPLIER':
        this.feedService.getUserProfileSuplier(userId).subscribe();
        break;
      case 'PRACTICE':
        this.feedService.getUserProfilePracice(userId).subscribe();
        break;
      case 'PROFESSIONAL':
        this.feedService.getUserProfileProfessional(userId).subscribe();
        break;
      case 'COMPANY':

        this.feedService.getCompanyDetails(userId).subscribe();
        break;
      default:
        console.warn('Unknown user type:', userType);
    }
  }


  getFollowLabel(status: string | null): string {
    switch (status) {
      case 'PENDING': return 'Pending';
      case 'APPROVED': return 'Following';
      default: return 'Follow';
    }
  }

  getFollowButtonLabel(user: any): string {
    const status = this.getStoredFollowStatus(user);
    return this.getFollowLabel(status);
  }

  // getStoredFollowStatus(user: any): string | null {
  //  return this.storedFollowStatuses?.[user.id] ?? user.followStatus ?? null;
  //}

  ngOnDestroy() {
    this.sls.remove('followingList')
    this.sls.remove('followerList')
  }

  bannerList: any;
  categoryList: any;
  filteredBannerList: any[] = [];
  rightNavBannerData: any[] = [];
  listViewBannerData: any[] = [];
  rightNavTimer: number = 1000;
  listViewTimer: number = 1000;

  // BANNER ADVERTISEMNT

  public rightNavBNSwiperConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: true,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    pagination: true,

    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
  }

  listViewRandomSwiperConfig(i: number) {
    const config = { ...this.listViewDynamicSwiperConfig() };
    config.initialSlide = Math.floor(i / 2) % this.listViewBannerData.length;
    return config;
  }

  listViewDynamicSwiperConfig(): SwiperConfigInterface {
    // Always return a new object to avoid shared state
    return { ...this.listViewBNSwiperConfig };
  }


  public listViewBNSwiperConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: this.listViewTimer,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: true,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    pagination: true,

    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
  }


  getFilteredBanners(): void {
    const filters = {
      status: 'APPROVED',
      category_names: ['All Right Nav Medium Banners', 'All News Feed List Banners'],
      banner_location: [
        'Web Right Nav News Feed',
        'Website News Feed List View',
      ],
    };

    this.bannersInfoTabService.getFilteredBannersData(filters).subscribe({
      next: (data) => {
        this.bannerList = data;
        this.filterBannersByCategory();
      },
    });
  }
  catalogueData:any;
  loadCatalogueData() {
       this.catalogueService.getMyCatalogueData(this.communityId ).subscribe(data => {
      this.catalogueData = data;
    });

  }

  courseData:any;
  loadCourseData() {
       this.CourseSectionService.getMyCourseData(this.communityId).subscribe(data => {
      this.courseData = data;
    });

  }

    getSeatStatus(item: any): { type: 'sold' | 'hurry' | 'fill', remaining: number } {
    const remaining = item.number_of_seats - item.course_registered_users_aggregate.aggregate.count;

    if (remaining <= 0) {
      return { type: 'sold', remaining: 0 };
    } else if (remaining <= 10) {
      return { type: 'hurry', remaining };
    } else {
      return { type: 'fill', remaining };
    }
  }

  getBannersCategory() {

    this.bannersInfoTabService.getBannersCategoryDatas().subscribe(data => {
      this.categoryList = data;
      // After categories loaded, filter

      const FindRightNavTimer = data.find(category =>
        category?.name === 'All Right Nav Medium Banners'
      )?.timer

      const FindListviewTimer = data.find(category =>
        category?.name === 'All News Feed List Banners'
      )?.timer

      this.updateRightNavTimer(FindRightNavTimer);
      this.UpdateListViewTimer(FindListviewTimer);


      this.filterBannersByCategory();
    });
  }

  updateRightNavTimer(newDelay: number): void {
    this.rightNavTimer = Number(newDelay) * 1000;

    this.rightNavBNSwiperConfig = {
      ...this.rightNavBNSwiperConfig,
      autoplay: {
        delay: this.rightNavTimer,
        disableOnInteraction: false,
      },
    };
  }
  UpdateListViewTimer(newDelay: number): void {
    this.listViewTimer = Number(newDelay) * 1000;

    this.listViewBNSwiperConfig = {
      ...this.listViewBNSwiperConfig,
      autoplay: {
        delay: this.listViewTimer,
        disableOnInteraction: false,
      },
    };
  }

  filterBannersByCategory() {

    if (!this.bannerList) return;


    // Filter Header job seek ocation -Website Header Banner
    const today = new Date().toISOString().slice(0, 10);
    const FilterRightNav = this.bannerList.filter(
      banner =>
        banner?.category_name === 'All Right Nav Medium Banners' && banner.schedule_date <= today
    );

    // Choose Admin or non-Admin banners based on existence
    const isAdminExistRight = FilterRightNav.some(b => b.company_name === 'ADMIN');

    const FilterRightNavData = FilterRightNav.filter(banner =>
      isAdminExistRight ? banner.company_name === 'ADMIN' : banner.company_name !== 'ADMIN'
    );


    this.rightNavBannerData = [];
    FilterRightNavData.forEach(banner => {
      banner.image?.forEach(img => {
        this.rightNavBannerData.push({
          img,
          id: banner.id,
          url: banner.url,
          category_name: banner.category_name,
          views: banner.views,
          banner_name: banner.banner_name

        });
      });
    });


    const FilterlistViewBanner = this.bannerList.filter(
      banner =>
        banner?.category_name === 'All News Feed List Banners' && banner.schedule_date <= today
    );

    // Choose Admin or non-Admin banners based on existence
    const isAdminExistList = FilterlistViewBanner.some(b => b.company_name === 'ADMIN');

    const FilterlistViewBannerData = FilterlistViewBanner.filter(banner =>
      isAdminExistList ? banner.company_name === 'ADMIN' : banner.company_name !== 'ADMIN'
    );


    this.listViewBannerData = [];
    FilterlistViewBannerData.forEach(banner => {
      banner.image?.forEach(img => {
        this.listViewBannerData.push({
          img,
          id: banner.id,
          url: banner.url,
          category_name: banner.category_name,
          views: banner.views,
          banner_name: banner.banner_name

        });
      });
    });

    this.getNewsFeed();

  }

  /**********  feed permition */
  private showAccessDenied(message: string, userType?: string): void {
    this.dialog.open(PermissionDeniedModalComponent, {
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      disableClose: true,
      width: '30%',
      data: {
        message: message,
        showContactAdmin: true,
        userType: userType
      }
    });
  }
  handleNewsfeedClick(): void {
    if (this.categoriesFilter.length === 0) {
      this.showAccessDenied('You have reached the limit for posting in all categories.', this.sls.get('loginData')?.type);
    } else {
      this.openDialog();
    }
  }
  loadUserNewsfeeds(): void {
    this.isLoading = true;
    const loginData = this.sls.get('loginData');

    if (!loginData || !loginData.id || !loginData.type) {
      console.error('Login data not available');
      this.isLoading = false;
      return;
    }

    this.feedService
      .getNewsfeedsByUserIds(loginData.id, loginData.type, 10, 0)
      .subscribe({
        next: (feeds) => {
          this.newsfeedsUser = feeds;
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error fetching newsfeeds:', err);
          this.isLoading = false;
        }
      });



  }

  checkCategoryPermissions(): void {


    const loginData = this.sls.get('loginData');
    this.subscriptionPermissions = loginData?.subscription_permissions;

    // If no subscription permissions exist, show all categories without restrictions
    if (!this.subscriptionPermissions?.modules) {
      this.feedService.getNewsFeedsCategories().subscribe({
        next: (categories) => {
          this.categoriesFilter = categories;
        },
        error: (err) => console.error('Error loading categories:', err)
      });
      return;
    }

    // Proceed with permission check if permissions exist
    const newsFeedPermission = this.subscriptionPermissions.modules.find(
      (module: any) => module.name === 'news_feed_modules_permission'
    );

    // If specific permission not found, treat as unlimited
    if (!newsFeedPermission) {
      this.feedService.getNewsFeedsCategories().subscribe({
        next: (categories) => {
          this.categoriesFilter = categories;
        },
        error: (err) => console.error('Error loading categories:', err)
      });
      return;
    }

    const allowedCategoryCount = newsFeedPermission.count;

    // Get all categories and user's newsfeeds
    this.feedService.getNewsFeedsCategories().subscribe({
      next: (allCategories) => {
        this.feedService.getNewsfeedsByUserId(loginData.id, loginData.type).subscribe({
          next: (feeds) => {
            // If count is 0 or negative, treat as unlimited
            if (allowedCategoryCount <= 0) {
              this.categoriesFilter = allCategories;
              return;
            }

            // Count usage per category
            const categoryUsageMap = new Map<string, number>();
            feeds.forEach(feed => {
              const currentCount = categoryUsageMap.get(feed.category_type) || 0;
              categoryUsageMap.set(feed.category_type, currentCount + 1);
            });

            // Filter categories based on usage vs allowance
            this.categoriesFilter = allCategories.filter(category => {
              const usedCount = categoryUsageMap.get(category.id) || 0;
              return usedCount < allowedCategoryCount;
            });

            console.log('Available categories with usage count:',
              this.categoriesFilter.map(cat => ({
                id: cat.id,
                name: cat.category_name,
                remaining: allowedCategoryCount - (categoryUsageMap.get(cat.id) || 0)
              }))
            );
          },
          error: (err) => console.error('Error loading user feeds:', err)
        });
      },
      error: (err) => console.error('Error loading categories:', err)
    });
  }
  /****** feed permition end */
  private rightNavBannerSlides() {
    this.observeBanners(
      this.RightNavBNSlideRefs,
      this.rightNavBannerData,
      this.rightNavViewedBNIds,
      this.rightNavBNObservers,
      'rightNav'
    );
  }

  // common view 
  private observeBanners(
    slideRefs: QueryList<ElementRef>,
    banners: any[],
    viewedIds: Set<number>,
    observersArray: IntersectionObserver[],
    type: 'rightNav' | 'list'
  ) {
    observersArray.forEach(observer => observer.disconnect());
    observersArray.length = 0;

    if (!slideRefs) return;

    slideRefs.forEach((slideRef: ElementRef, index: number) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const banner = banners[index];

            if (banner && !viewedIds.has(banner.id)) {
              banner.views = (banner.views || 0) + 1;
              viewedIds.add(banner.id);
              const viewscount = { views: banner.views };
              this.bannersInfoTabService.updateBanner(banner.id, viewscount).subscribe();
            }
          }
        });
      }, { threshold: 0.5 });

      observer.observe(slideRef.nativeElement);
      observersArray.push(observer);
    });
  }

  private listViewBNSlides() {
    // Clear previous tracking
    this.listviewedBNIds = [];

    const allSlides = this.listViewBNSlideRefs.toArray();
    const bannersPerSwiper = 1; // each swiper is injected every 5 items (update if needed)

    let swiperIndex = -1;
    for (let i = 0; i < allSlides.length; i++) {
      if (i % this.listViewBannerData.length === 0) {
        swiperIndex++;
        this.listviewedBNIds[swiperIndex] = new Set<number>();
      }

      this.observeSingleBanner(
        allSlides[i],
        this.listViewBannerData[i % this.listViewBannerData.length],
        this.listviewedBNIds[swiperIndex],
        swiperIndex
      );
    }
  }


  private observeSingleBanner(
    slideRef: ElementRef,
    banner: any,
    viewedIds: Set<number>,
    swiperIndex: number
  ) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (banner && !viewedIds.has(banner.id)) {
            banner.views = (banner.views || 0) + 1;
            viewedIds.add(banner.id);
            const viewscount = { views: banner.views };
            this.bannersInfoTabService.updateBanner(banner.id, viewscount).subscribe();

          }
        }
      });
    }, { threshold: 0.5 });

    observer.observe(slideRef.nativeElement);
    this.listViewBNObservers.push(observer);
  }

  trackByfeedId(index: number, feed: any): string {

    return feed.id;
  }

  goToCatalogueDetails(id: string) {
    if (id) this.router.navigate(['/catalogues/details', id]);
  }

  goToCourseDetails(id: string) {
    if (id) this.router.navigate(['/learning/learning-hub-details', id]);
  }

  leaveCommunity() {
  if (!this.communityId) return;

  const dialogRef = this.dialog.open(DeletePopupComponent, {
    width: '600px',
    data: {
      item: this.communityId,
      name: this.communityName || 'Community',
      static:'communityData',
      message: `Are you sure you want to leave ${this.communityName} Community?`
    },
    scrollStrategy: this.overlay.scrollStrategies.noop(),
  });

  dialogRef.afterClosed().subscribe((response) => {
    if (response === 'yes') {
      const where = {
        _and: [
          { community_id: { _eq: this.communityId } },
          { member_id: { _eq: this.loginDetails.id } },
        ],
      };

      this.Commonservice.DeleteByCondition(Tables.Community_Members, where)
        .then((res: any) => {
          const affected =
            res?.data?.[`delete_${Tables.Community_Members}`]?.affected_rows || 0;

          if (affected > 0) {
            this.toast.openSnackBar('You have left the community successfully');
            this.router.navigate(['/profile/my-dashboard']); 
          } else {
            this.toast.openSnackBar('You were not a member of this community');
          }
        })
        .catch((err) => {
          console.error('Error leaving community:', err);
          this.toast.openSnackBar('Failed to leave community');
        });
    }
  });
}

} 
